import {FC, useState, useEffect} from 'react'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Col, Dropdown, Row} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import FormModal from './FormModal'

const api = new Api()

const heads = [
  {
    name: '',
    label: 'Email',
  },
  {
    name: '',
    label: 'Role',
  },
  {
    name: '',
    label: 'Kode User',
  },
  {
    name: '',
    label: 'Nama User',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const AccountManagementPage: FC = () => {
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })

  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({})
  const [data, setData] = useState<any>([])

  const paginator: any = usePagination({
    totalCount: data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    fetchData()
  }, [query])

  useEffect(() => {
    generateTotalPage(pagination.total_page)
    fetchData()
  }, [pagination.per_page, pagination.page])

  const fetchData = () => {
    setLoading(true)
    api
      .getUser({
        ...query,
        page: pagination.page,
        sort_field: 'created_at',
        per_page: pagination.per_page,
      })
      .then((response: any) => {
        setLoading(false)
        const data = response.data
        setData(data.data)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const handleClose = (isShow: boolean) => {
    setFormValue({})
    setShow(isShow)
    fetchData()
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }

    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  return (
    <div className='row'>
      <FormModal showFormModal={show} handleCloseFormModal={handleClose} formData={formValue} />

      <div className='col-md-12'>
        <div className='card-custom'>
          <Row>
            <Col md={{span: 4}}>
              <input
                className='form-control'
                type='text'
                placeholder='Cari...'
                onChange={(e) => setQuery({...query, q: e.target.value})}
              />
            </Col>

            <Col md={{span: 2, offset: 4}}>
              <button
                type='button'
                className='btn btn-primary form-control'
                onClick={() => setShow(true)}
              >
                + Tambah
              </button>
            </Col>

            <Col md={{span: 2}}>
              <select
                className='mr-8 form-control'
                onChange={(e) => {
                  setQuery({...query, sort_order: e.target.value})
                }}
              >
                <option value='desc'>Terbaru</option>
                <option value='asc'>Terlama</option>
              </select>
            </Col>
          </Row>

          <Row md={12} className='mt-8'>
            <div className='table-responsive'>
              <table className='table table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.map((item: any, key: any) => {
                    return (
                      <tr key={key}>
                        <td>{(pagination?.page - 1) * pagination?.per_page + key + 1}</td>
                        <td>{item.email}</td>
                        <td>
                          {item?.roles?.map((roleItem: any, index: number) => (
                            <div key={index}>
                              <span className='badge badge-secondary mt-2'>
                                {roleItem?.roles_name}
                              </span>
                            </div>
                          ))}
                        </td>
                        <td>{item.users_kode}</td>
                        <td>{item.users_firstname}</td>
                        <td>
                          {item.users_status == 0 ? (
                            <button className='btn btn-secondary btn-sm btn-outline btn-outline-dark'>
                              Nonaktif
                            </button>
                          ) : (
                            <button className='btn btn-sm btn-outline btn-outline-success'>
                              Aktif
                            </button>
                          )}
                        </td>
                        <td>
                          <Button
                            className='btn-sm'
                            onClick={() => {
                              setFormValue({
                                id: item.users_id,
                                firstname: item?.users_firstname,
                                lastname: item?.users_lastname,
                                email: item.email,
                                code_phone: item?.detail?.user_details_code_phone,
                                phone_number: item?.detail?.user_details_phone,
                                status: item.users_status,
                                id_hash: item?.id_hash,
                                gender: item?.detail?.user_details_gender,
                                roles: item?.roles,
                              })

                              setShow(true)
                            }}
                          >
                            Edit
                          </Button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </Row>
          <Row>
            <Col md={6}>
              {data?.data?.length > 0 && !loading && (
                <div style={{float: 'left'}}>
                  <Dropdown>
                    <Dropdown.Toggle className='btn btn-sm'>{pagination.per_page}</Dropdown.Toggle>
                    <Dropdown.Menu>
                      {[10, 25, 50, 100].map((item: any) => (
                        <Dropdown.Item
                          key={item}
                          onClick={() => onChangePerPage(item)}
                          disabled={pagination.per_page === item}
                        >
                          {item}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </Col>
            <Col md={6}>
              <div style={{float: 'right'}}>
                {!loading && (
                  <Pagination className='btn-sm'>
                    {paginator?.map((item: any) => {
                      return (
                        <Pagination.Item
                          className='btn-sm'
                          key={item}
                          active={item === pagination.page}
                          onClick={() => onChangePerPage(pagination.per_page, item)}
                          disabled={item === '...'}
                        >
                          {item}
                        </Pagination.Item>
                      )
                    })}
                  </Pagination>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

const AccountManagement: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        List Admin
      </PageTitle>
      <AccountManagementPage />
    </>
  )
}

export default AccountManagement
